/**
 * Custom Parameter Icon Component
 * 
 * Displays custom musician-specific parameters like drummer kit parts,
 * keyboard range, or special effects indicators.
 */

import React from 'react';
import { useMusicianConfig } from '../hooks/useMusicianConfig';
import { CUSTOM_PARAM_INTERFACES, DRUMMER_KIT_PARTS, CUSTOM_EFFECT_ICONS } from '../config/musicians';
import { Knob } from './Knob';
import './Icon.css';

/**
 * Custom parameter display component
 * 
 * @param {object} props - Component props
 * @param {*} props.state - Custom parameter state (varies by interface type)
 * @param {string} props.customInterface - Interface type identifier
 */
export function CustomParameterIcon({ state, customInterface }) {
  const { musicianName } = useMusicianConfig();
  
  // Handle drummer kit parts interface
  if (
    customInterface === CUSTOM_PARAM_INTERFACES.DRUMMER_KIT_PARTS ||
    customInterface === CUSTOM_PARAM_INTERFACES.LEAD_ELEMENT
  ) {
    if (musicianName === 'Drummer' || musicianName === 'Eldar Moshe') {
      const paramNumber = typeof state === 'number' ? state : 0;
      const displayText = DRUMMER_KIT_PARTS[paramNumber] || 'ANY';
      
      return (
        <div className="drummer-custom-param">
          {displayText}
        </div>
      );
    }
  }
  
  // Handle keyboard range interface
  if (customInterface === CUSTOM_PARAM_INTERFACES.KEYBOARD_RANGE) {
    if (Array.isArray(state) && state.length === 2) {
      return (
        <div className="keyboard-range-param">
          <Knob label="" range={state} />
        </div>
      );
    }
  }
  
  // Default: show custom effect icon
  const iconName = CUSTOM_EFFECT_ICONS[musicianName] || 'stereo_double';
  const iconPath = `./${iconName}.svg`;
  
  // Determine icon class based on state
  let className = 'filter-icon-on';
  
  if (Array.isArray(state) && state.length === 2) {
    const [left, right] = state;
    if (left === false && right === true) {
      className = 'filter-icon-on';
    } else if (left === true && right === false) {
      className = 'filter-icon-off';
    } else if (left === true && right === true) {
      className = 'filter-icon-on-off';
    }
  }
  
  return <img className={className} src={iconPath} alt="Special Effect" />;
}


